import React from "react";
import SEO from "../components/SEO";
import UrgencyBanner from "../components/UrgencyBanner";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Benefits from "../components/Benefits";
import Curriculum from "../components/Curriculum";
import ToolsMarquee from "../components/ToolsMarquee";
import Audience from "../components/Audience";
import Foundation from "../components/Foundation";
import PrimaCariera from "../components/PrimaCariera";
import Pricing from "../components/Pricing";
import CourseSchedule from "../components/CourseSchedule";
import NextWebinar from "../components/NextWebinar";
import Testimonials from "../components/Testimonials";
import Faq from "../components/Faq";
import LeadForm from "../components/LeadForm";
import Footer from "../components/Footer";
import StickyCTA from "../components/StickyCTA";
import WhatsappFab from "../components/WhatsappFab";
import ExitIntent from "../components/ExitIntent";
import CookieConsent from "../components/CookieConsent";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#F5F6F6]" data-testid="landing-page">
      <SEO
        title="Introducere în Inteligența Artificială pentru educație | FPED"
        description="Curs online pentru cadre didactice despre utilizarea inteligenței artificiale în pregătire, predare și evaluare. Program dezvoltat de Fundația pentru Educație Digitală."
        canonical="https://ai.fped.org/"
      />
      <UrgencyBanner />
      <Header />
      <main>
        <Hero />
        <Benefits />
        <Curriculum />
        <ToolsMarquee />
        <Audience />
        <Foundation />
        <PrimaCariera />
        <NextWebinar />
        <Pricing />
        <CourseSchedule />
        {/* Real testimonials from the final feedback, shown from 3 published (30.10.2026). */}
        <Testimonials />
        <Faq />
        <LeadForm />
      </main>
      <Footer />
      <StickyCTA />
      <WhatsappFab />
      <ExitIntent />
      <CookieConsent />
    </div>
  );
}
